import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import {featureInterface} from "../../../interfaces/featureInterface";
import {getFeatureOptions, getOptionStyles} from "../lookNavigation/lookFunctions";
import {capitalizeFirstLetters} from "../../../misc/helpers";


const ShopFeatureOptionsCommon = (props) => {

  const {feature, filterGroups, optionsButtonClick, withTitle, navItemOptions, navigationCount, selectedFilters} = props;

  const [availableOptions, setAvailableOptions] = useState([]);

  const optionsName = feature.getMatchingOptionsName();

  useEffect(() => {
    if (!filterGroups || !filterGroups.length) {
      return
    }
    const colorOptions = getFeatureOptions(feature, filterGroups, true, navItemOptions, selectedFilters);
    // console.log("colorOptions", colorOptions);
    setAvailableOptions(colorOptions || [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature.partId, optionsName, navigationCount, selectedFilters]);

  if (!availableOptions.length) {
    return null
  }

  const activeOption = availableOptions.find(colorOption => colorOption.feature.dbFeature.id === feature.dbFeature.id)

  const activeOptionText = withTitle && activeOption
    ? capitalizeFirstLetters((activeOption.colorValue.displayText || activeOption.colorValue.value).replace("GROHE ", ""))
    : null;

  return (
    <div className="lk-feature__options">
      {withTitle ? (
        <h3 className="shop-feature__sub-title">
          <FormattedMessage id="grohe.filter.color"/>:
          <span className="lk-feature__options-title-text">{activeOptionText}</span>
        </h3>
      ) : null}
      <ul className="lk-feature__options-list lk-feature__options-list--small">
        {availableOptions.map(option => {
          const isActive = activeOption && (option.colorValue.id === activeOption.colorValue.id);
          const styles = getOptionStyles(option.colorValue);
          return (
            <li className={"lk-color lk-color--" + option.colorValue.id +  (isActive ? " lk-color--active" : "")}
                key={option.colorValue.id}
                onClick={() => optionsButtonClick(option)}
                style={styles}/>
          )
        })}
      </ul>
    </div>
  )
};

ShopFeatureOptionsCommon.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired,
  activeOption: PropTypes.object,
  optionsButtonClick: PropTypes.func.isRequired,
  withTitle: PropTypes.bool,
  navItemOptions: PropTypes.arrayOf(PropTypes.shape(featureInterface)),
}

const mapStateToProps = (store) => {
  // const {isMobile} = store.serverState;
  // const {filterGroups, selectedFilters} = store.filterState;
  const {filterGroups, selectedFilters} = store.filterState;
  // const fabricatorData = store.fabricatorState;
  // const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {navigationCount} = store.lookState;
  // const {groheFiltersSearchText} = store.groheState;

  return {
    // isMobile,
    // fabricatorData,
    // isPhoneNumberValidated,
    filterGroups,
    navigationCount,
    selectedFilters,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopFeatureOptionsCommon)
)
